import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {UrlProviderService} from '../../../shared/services/general';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {

  constructor(
    private urlProvider: UrlProviderService,
    private httpClient: HttpClient,
  ) {
  }

  public getResultSettings(): Observable<{ abnormalResult: string; normalResult: string }> {
    return this.httpClient.get<{ abnormalResult: string; normalResult: string }>(
      `${this.urlProvider.ApiUrl}/v2/public-settings/toxicology-results`,
    ).pipe(retry(2));
  }

  public getWebResultSettings() {
    return this.httpClient.get<any>(`${this.urlProvider.ApiUrl}/v2/public-settings/web-results`).pipe(retry(2));
  }

  public IsMissingInfoEnabled() {
    return this.httpClient.get<any>(`${this.urlProvider.ApiUrl}/v2/public-settings/missing-info`).pipe(retry(2));
  }
}
